/* global Turbo */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    token: String,
    page: Number
  }

  visit(event) {
    // Prevent nested links interception
    if (event.target.closest('a') !== this.element) return

    event.preventDefault()
    const url = new URL(this.element.href)

    if (this.tokenValue) url.searchParams.set('slideshow[token]', this.tokenValue)
    if (this.pageValue) url.searchParams.set('slideshow[page]', this.pageValue)

    Turbo.visit(url.toString(), { frame: 'pictures--slideshow-modal' })
  }
}
